import { render, staticRenderFns } from "./index.vue?vue&type=template&id=505f1a06&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=505f1a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f1a06",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./index.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBlogList: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/site/blog/list.vue').default,WidgetsFormsAddress: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/address.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/image.vue').default,ProductsMenu: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/products/menu.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/site/feefo.vue').default})
